import { AfterViewInit, Component, OnInit, ViewChild, NgZone, ElementRef, VERSION, Inject, Input } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables'; import { dataService } from '../../services/data.service';
import { DOCUMENT } from '@angular/common';
import { logbaseService } from '../../services/logbase.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-supplier-management',
  templateUrl: './supplier-management.component.html',
  styleUrls: ['./supplier-management.component.scss']
})
export class SupplierManagementComponent implements OnInit {

  
  totalItems: any;
  userIDTaken: boolean;
  supplierCode: any = [];
  loggedInUser: any;
  adminAccess: any;
  settings: { idField: string; textField: string ; singleSelection: boolean; text: string; enableSearchFilter: boolean; };
  settingsoperation: { idField: string; textField: string ;singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; itemsShowLimit: number; };
  settingslogistic: { idField: string; textField: string ;singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; itemsShowLimit: number; };
  settingssmvs: {idField: string; textField: string ; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean;  itemsShowLimit: number; };
  settingsquality: { idField: string; textField: string ;singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean;  itemsShowLimit: number; };
  logisticitemSelected: any = [];
  operationitemSelected: any = [];
  smvsCodes: any;
  logisticCodes: any;
  operationCodes: any;
  smqualityitemSelected: any = [];
  smvsitemSelected: any = [];
  smqualityCodeList: any[]=[];
  smvsCodeList: any[];
  logisticCodeList: any[];
  operationCodeList: any[];
  smqualityCodes: any;
  ArrayList: { id: number; itemName: string; }[];
  suppCodeList: any;
  supplierCodes;
  itemSelected: any = [];
  userCount: any;
  users: any;
  selectedItems: {}[];
  smqualityCode: any = [];
  smvsCode: any = [];
  logisticCode: any = [];
  operationCode: any = [];
  opBySuppCode: any = [];
  todayDate: any;
  //@ViewChild(DataTableDirective)
  //dtElement: DataTableDirective;

  //datatableElement: DataTableDirective;

  //dtOptions: DataTables.Settings = {};
  // parts: newParts[] = [];
  //dtTrigger: Subject<any> = new Subject();
  message = '';
  config;
  options;
  singleSelect: any = [];
  stringOptions;
  selectedOptions;
  optionsCodeList;
  modalRef: NgbModalRef;
  suppDetails: any;
  supplogList: any;
  suppSMQList: any;
  suppSMVSList: any;
  


  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: any, private logbaseService: logbaseService, private translate: TranslateService,
    private dataService: dataService, private toastr: ToastrService, private spinner: NgxSpinnerService, private modalService: NgbModal) {
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.loggedInUser = userDetJson.loginId;
    this.adminAccess = userDetJson.userRoleMappings[0].roleId;
  }

  ngOnInit(): void {
    this.singleSelect = [];
    this.stringOptions = [
      "Burns Dalton", "Mcintyre Lawson", "Amie Franklin", "Jocelyn Horton", "Fischer Erickson", "Medina Underwood", "Goldie Barber"
    ]

    this.config = {
      displayKey: "name", //if objects array passed which key to be displayed defaults to description
      search: true,
      limitTo: 10
    };

    var smqualityListArr = [];

    this.spinner.show();
    this.userIDTaken = true;

    this.logbaseService.getAvailableSupplierCodesAndUsers()
      .subscribe(result => {
        this.supplierCodes = result.response.SUPPLIER_CODES;
        let suppCodeListArr = [];
        if (this.supplierCodes) {
          let i = 0;
          this.optionsCodeList = this.supplierCodes;

          this.supplierCodes.forEach(function (value) {
            suppCodeListArr.push({ "id": i + 1, "itemName": value });
            i++;
          });
        }

        this.suppCodeList = suppCodeListArr;
        this.supplierCode = ''
      });
    this.spinner.show();
    this.logbaseService.getAvailableSupplierCodesAndUsers()
      .subscribe(result => {
        this.smqualityCodes = result.response.SMQ;

        if (this.smqualityCodes) {
          let i = 0;
          this.smqualityCodes.forEach(function (value) {
            smqualityListArr.push({ "id": i + 1, "itemName": value });
            i++;
          });
          this.smqualityCodeList = smqualityListArr;
        }
      });

    this.spinner.show();
    this.logbaseService.getAvailableSupplierCodesAndUsers()
      .subscribe(result => {
        this.smvsCodes = result.response.SMVS;
        let smvsListArr = [];
        if (this.smvsCodes) {
          let i = 0;
          this.smvsCodes.forEach(function (value) {
            smvsListArr.push({ "id": i + 1, "itemName": value });
            i++;
          });
        }
        this.smvsCodeList = smvsListArr;
      });
    this.spinner.show();
    this.logbaseService.getAvailableSupplierCodesAndUsers()
      .subscribe(result => {
        this.logisticCodes = result.response.LOGISTICS;
        let logisticListArr = [];
        if (this.logisticCodes) {
          let i = 0;
          this.logisticCodes.forEach(function (value) {
            logisticListArr.push({ "id": i + 1, "itemName": value });
            i++;
          });
        }
        this.logisticCodeList = logisticListArr;
      });
    this.spinner.show();
    this.logbaseService.getAvailableSupplierCodesAndUsers()
      .subscribe(result => {
        this.operationCodes = result.response.OPERATION;
        let operationListArr = [];
        if (this.operationCodes) {
          let i = 0;
          this.operationCodes.forEach(function (value) {
            operationListArr.push({ "id": i + 1, "itemName": value });
            i++;
          });
        }
        this.operationCodeList = operationListArr;
      });

    this.selectedItems = [];
    this.settings = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: true,
      text: "Supplier Code",
      enableSearchFilter: true
    };
    this.settingsquality = {
      singleSelection: false,
      text: "SM Quality",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      idField: 'id',
      textField: 'itemName',
      itemsShowLimit: 10,

    };

    this.settingssmvs = {
      singleSelection: false,
      text: "SMVS",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      idField: 'id',
      textField: 'itemName',
      itemsShowLimit: 10,
    };

    this.settingslogistic = {
      singleSelection: false,
      text: "Logistic",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      idField: 'id',
      textField: 'itemName',
      itemsShowLimit: 10,
    };

    this.settingsoperation = {
      singleSelection: false,
      text: "Operations",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      idField: 'id',
      textField: 'itemName',
      itemsShowLimit: 10,
    };

    /*this.dtOptions = {
      pagingType: 'simple_numbers',
      dom: '<"top"<"row"<"col-md-10 text-right"<"#dtpagination"p>><"col-md-2 text-right"<"#dtlength"l>><"clear">>><"#dtSearch"f>t<"bottom"<"clear">>',
      language: {
        search: "_INPUT_",
        searchPlaceholder: this.translate.instant("Search by: Name ,Email, Contact..."),
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        // Unbind first in order to avoid any duplicate handler
        // (see https://github.com/l-lin/angular-datatables/issues/87)
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
          //self.someClickHandler(data);
        });
        return row;
      }
    };*/

    // Get current date
    this.todayDate = Date.now();
   /* this.logbaseService.getSupplierMasterData()

      .subscribe(result => {
        this.users = result.response;
        this.userCount = this.users.length;
        localStorage.setItem('usersData', JSON.stringify(this.users));
        // set data in service which is to be shared
        this.dataService.setpartAPIData(result.response);

        // Calling the DT trigger to manually render the table
        this.dtTrigger.next();
      })*/

      var paginationData={
        pageNum: 0,
        pageSize: 10,
      }

      this.logbaseService.getSupplierMasterDataPaginated(paginationData).subscribe(result=>{
        this.users = result.response.content;
        this.totalItems=result.response.totalElements;
        this.userCount = this.users.length;
        localStorage.setItem('usersData', JSON.stringify(this.users));
        // set data in service which is to be shared
        this.dataService.setpartAPIData(result.response);

        this.spinner.hide();

        // Calling the DT trigger to manually render the table
        //this.dtTrigger.next();

      })
    //this.spinner.hide();
  }

  numPages=1;
  page;

  onChangeTable(event){

    this.spinner.show();
    var paginationData={
      pageNum: event.page-1,
      pageSize: 10,
    }
    
    this.logbaseService.getSupplierMasterDataPaginated(paginationData).subscribe(result=>{
      this.users = result.response.content;
      this.spinner.hide();

    })
  }

  searchText: any;
  searchText1: any;

  onSearch(){
    this.spinner.show();
    var paginationData={
      pageNum: 0,
      pageSize: 10,
      searchValue: this.searchText
    }
    
    this.logbaseService.getSupplierMasterDataPaginated(paginationData).subscribe(result=>{
      this.users = result.response.content;
      this.spinner.hide();

    })
  }

  updateUser(item: any) {
    this.supplierCodes = []
    this.smqualityCode = [];
    this.smvsCode = [];
    this.logisticCode = [];
    this.operationCode = [];
    this.spinner.show();
    this.logbaseService.getSupplierCodeDataSupplierManagement(item)
      .subscribe(result => {
        this.supplierCodes = result.response;
        //Supplier Manager Auto Selection based on DropDown
        var suppCodeListArr = [];
        let i = 0;
        if (this.supplierCodes.supplierManagerQs == null) {
          this.smqualityCode = suppCodeListArr;
        } else {
          var tempSmQualityCode = this.smqualityCodeList;
          this.supplierCodes.supplierManagerQs.forEach(function (value) {
            var index = tempSmQualityCode.find(x => x.itemName === value.smqUserId);
            if (index != undefined) {
              suppCodeListArr.push({ "id": index.id, "itemName": value.smqUserId });
            }
          });

          this.smqualityCode = suppCodeListArr;
          let opBysmqCode = [];
          this.smqualityCode.forEach(function (value) {
            opBysmqCode.push(value.itemName);
          });
          this.smqualityitemSelected = opBysmqCode;
        }
        //SMvs Auto Selection based on DropDown
        let smvsListArr = [];
        let x = 0;

        if (this.supplierCodes.supplierManagerVSs == null) {
          this.smvsCode = smvsListArr;
        } else {
          var tempSmVSCode = this.smvsCodeList;
          this.supplierCodes.supplierManagerVSs.forEach(function (value) {
            var index = tempSmVSCode.find(x => x.itemName === value.smvsUserId);
            if (index != undefined) {
              smvsListArr.push({ "id": index.id, "itemName": value.smvsUserId });
            }
          });
          this.smvsCode = smvsListArr;
          let opBysmvsCode = [];
          this.smvsCode.forEach(function (value) {
            opBysmvsCode.push(value.itemName);
          });

          this.smvsitemSelected = opBysmvsCode;
        }
        //Logistic Auto Selection based on DropDown
        let logisticListArr = [];
        let y = 0;

        if (this.supplierCodes.logistics == null) {
          this.logisticCode = logisticListArr;
        }
        else {
          var tempLogisticCode = this.logisticCodeList;
          this.supplierCodes.logistics.forEach(function (value) {
            var index = tempLogisticCode.find(x => x.itemName === value.logisticsUserId);
            if (index != undefined) {
              logisticListArr.push({ "id": index.id, "itemName": value.logisticsUserId });
            }

          });
          this.logisticCode = logisticListArr;
          let opByLogisticCode = [];
          this.logisticCode.forEach(function (value) {
            opByLogisticCode.push(value.itemName);
          });

          this.logisticitemSelected = opByLogisticCode;
        }

        //Operation Auto Selection based on DropDown
        let operationListArr = [];
        let z = 0;
        if (this.supplierCodes.operations == null) {
          this.operationCode = operationListArr;
          //this.spinner.hide();
        }
        else {
          this.supplierCodes.operations.forEach(function (value) {
            operationListArr.push({ "id": z + 1, "itemName": value });
            z++;
          });
          this.operationCode = operationListArr;

          let opBySuppCode = [];
          this.operationCode.forEach(function (value) {
            opBySuppCode.push(value.itemName);
          });

          this.operationitemSelected = opBySuppCode;
        }

        this.spinner.hide();
      });
  }

  onSingleSelect(item: any) {
    this.itemSelected = [];
    this.itemSelected.push(item.value[0]);
    this.updateUser(item.value[0]);
    this.userIDTaken = false;
  }

  onSingleDeSelect(item: any) {
    this.itemSelected.pop(item.itemName);
    this.userIDTaken = true;
  }

  // SM Qauality Starts
  onItemSelect(item: any) {
    this.smqualityitemSelected.push(item.itemName);
  }
  OnItemDeSelect(item: any) {
    let index = this.smqualityitemSelected.indexOf(item.itemName);
    this.smqualityitemSelected.splice(index, 1);
  }
  onSelectAll(items: any) {
    items.forEach(element => {
      this.smqualityitemSelected.push(element.itemName);
    });
  }
  onDeSelectAll(items: any) {
    this.smqualityitemSelected = []
  }
  //SM Quality Ends

  //SMVS STARTS
  onItemSelectsmvs(item: any) {
    this.smvsitemSelected.push(item.itemName)
  }
  OnItemDeSelectsmvs(item: any) {
    let index = this.smvsitemSelected.indexOf(item.itemName);
    this.smvsitemSelected.splice(index, 1);
  }
  onSelectAllsmvs(items: any) {
    items.forEach(element => {
      this.smvsitemSelected.push(element.itemName);
    });
  }
  onDeSelectAllsmvs(items: any) {
    this.smvsitemSelected = []
  }

  //LOGISTIC STARTS
  onItemSelectlogistic(item: any) {
    this.logisticitemSelected.push(item.itemName)
  }
  OnItemDeSelectlogistic(item: any) {
    let index = this.logisticitemSelected.indexOf(item.itemName);
    this.logisticitemSelected.splice(index, 1);
  }
  onSelectAlllogistic(items: any) {
    items.forEach(element => {
      this.logisticitemSelected.push(element.itemName);
    });
  }
  onDeSelectAlllogistic(items: any) {
    this.logisticitemSelected = []
  }
  //LOGISTIC ENDS

  //Operations STARTS
  onItemSelectoperation(item: any) {
    this.operationitemSelected.push(item.itemName)
  }
  OnItemDeSelectoperation(item: any) {
    let index = this.operationitemSelected.indexOf(item.itemName);
    this.operationitemSelected.splice(index, 1);
  }
  onSelectAlloperation(items: any) {
    items.forEach(element => {
      this.operationitemSelected.push(element.itemName);
    });
  }
  onDeSelectAlloperation(items: any) {
    this.operationitemSelected = []
  }
  //OPERATIONS ENDS
  postFormError() {
    this.toastr.warning('Problem while Submission, Kindly check your network status');
  }
  registerationSuccess() {
    this.toastr.success(this.translate.instant('User Updated Successfully'));
  }
  ngAfterViewInit(): void {
  }
  private extractData(res: HttpResponse<any>) {
    const body = res.body.json();
    return body.data || {};
  }

  addUser() {
    var itemSelected = this.itemSelected.toString();
    var adminRoleId = this.adminAccess.toString();
    let adduserData = {
      "supplierCode": itemSelected,
      "supplierManagerQs": this.smqualityitemSelected,
      "supplierManagerVSs": this.smvsitemSelected,
      "logistics": this.logisticitemSelected,
      "operations": this.operationitemSelected,
      "roleId": adminRoleId
    }
    this.spinner.show();
    this.logbaseService.createSupplierManagementUserPostCall(adduserData)
      .subscribe(
        data => {
          // set success message and pass true paramater to persist the message after redirecting to the login page
          this.registerationSuccess();
          //this.rerender();
          this.smqualityCode = [];
          this.smvsCode = [];
          this.logisticCode = [];
          this.operationCode = [];
          this.supplierCode = [];
          this.singleSelect = ''
          //location.reload();
          this.spinner.hide();
          this.userIDTaken = true;
        },
        error => {
          this.postFormError();
          this.spinner.hide();
        });
  }

 /* rerender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.logbaseService.getSupplierMasterData()
        .subscribe(result => {
          this.users = result.response;
          this.dtTrigger.next();
          this.spinner.hide();
        });
    });

  }*/

  editMapping(mapModal, item) {
    var logList = [];
    var smQList = [];
    var smvsList = [];
    this.suppDetails = item;

    var logisticCodeList = this.logisticCodeList;
    var smvsCodeList = this.smvsCodeList;
    var smqualityCodeList = this.smqualityCodeList;

    item.logistics.forEach(function (value) {
      let index = logisticCodeList.find(x => x.itemName === value.logisticsUserId);
      if (index != undefined) {
        logList.push({ "id": index.id, "itemName": value.logisticsUserId });
      }
    });

    this.supplogList = logList;

    item.supplierManagerQs.forEach(function (value) {
      let index = smqualityCodeList.find(x => x.itemName === value.smqUserId);
      if (index != undefined) {
        smQList.push({ "id": index.id, "itemName": value.smqUserId });
      }
    });
    this.suppSMQList = smQList;

    item.supplierManagerVSs.forEach(function (value) {
      let index = smvsCodeList.find(x => x.itemName === value.smvsUserId);
      if (index != undefined) {
        smvsList.push({ "id": index.id, "itemName": value.smvsUserId });
      }
    });
    this.suppSMVSList = smvsList;

    this.modalRef = this.modalService.open(mapModal, { size: 'lg' });
    this.modalRef.result.then((result) => {
    });
  };

  updateSupplierMap(item: any) {
    var itemSelected = this.itemSelected.toString();
    var adminRoleId = this.adminAccess.toString();

    var SMQSel = [];
    var SMVSSel = [];
    var logSel = [];

    this.suppSMQList.forEach(value => {
      SMQSel.push(value.itemName);
    });
    this.suppSMVSList.forEach(value => {
      SMVSSel.push(value.itemName);
    });
    this.supplogList.forEach(value => {
      logSel.push(value.itemName);
    });

    let updateUserData = {
      "supplierCode": this.suppDetails.supplierCode,
      "supplierManagerQs": SMQSel,
      "supplierManagerVSs": SMVSSel,
      "logistics": logSel,
      "operations": [],
      "roleId": adminRoleId
    }
    this.spinner.show();
    this.logbaseService.createSupplierManagementUser(updateUserData)
      .subscribe(
        data => {
          // set success message and pass true paramater to persist the message after redirecting to the login page
          this.registerationSuccess();
          //this.rerender();
          this.smqualityCode = [];
          this.smvsCode = [];
          this.logisticCode = [];
          this.operationCode = [];
          this.supplierCode = [];
          this.singleSelect = ''
          //location.reload();
          this.spinner.hide();
          this.userIDTaken = true;
          this.modalRef.close();
        },
        error => {
          this.postFormError();
          this.spinner.hide();
        });
  };
}
